Drupal.behaviors.sw_infinite_scroll = {
  attach: function( context, settings ) {

    $('.js-infinite-scroll-wrapper').once('sw-infinite-scroll').each(function() {
      let i = new SwInfiniteScroll($(this));
    });

  }
};

$(window).scroll(function() {
  $('.js-infinite-scroll-wrapper').each(function() {
    let i = $(this).data('sw-infinite-scroll');
    if ( i ) {
      i.on_scroll();
    }
  });
});

let SwInfiniteScroll = function( $wrap ) {
  let _this = this;

  this.$wrap = $wrap;

  this.id = this.$wrap.attr('id');
  this.loading = false;

  this.$wrap.on('click', '.js-infinite-scroll-button-wrap a', function(e) {
    e.preventDefault();
    _this.load_more($(this));
  });

  this.$wrap.data('sw-infinite-scroll', this);
}

SwInfiniteScroll.prototype.on_scroll = function() {
  let $bw = this.$wrap.find('.js-infinite-scroll-button-wrap');
  if ( $bw.length ) {
    let st = $(window).scrollTop();
    let wh = $(window).height();
    let bot = $bw.offset().top;
    if ( st + wh > bot + 100 ) {
      this.load_more($bw.find('a').first());
    }
  }
}

SwInfiniteScroll.prototype.load_more = function($a) {
  let _this = this;
  if ( this.loading ) {
    return;
  }
  this.loading = true;
  let ta = $a.text();
  $a.text('Loading...');
  //$a.append(wait());
  $a.addClass('disabled');
  this.ajax = $.ajax({
    url: $a.attr('href'),
    method: 'GET',
    dataType: 'html',
    success: function ( resp ) {
      _this.$wrap.find('.js-infinite-scroll-button-wrap').remove();
      _this.$wrap.append($(resp).find('#'+_this.id+'.js-infinite-scroll-wrapper').html());
      Drupal.attachBehaviors();
      _this.loading = false;
    },
    error: function ( xhr, status, error ) {
      console.error ( 'AJAX error! ' + status + ', ' + error );
      $a.text('Unable to load')
      setTimeout(function() {
        $a.text(ta);
        $a.removeClass('disabled');
        _this.loading = false;
      }, 1000);
    }
  });
};
